import React from "react";
import { useSelector } from "react-redux";
import { useImmer } from "use-immer";

import { Grid } from "@mui/material";
import { useGetAllCombinedCustomEvents } from "@src/api/custom-events/get-all-combined-custom-events";
import { useGetOrg } from "@src/api/organizations/get-organization";
import { combinedCustomEventsKeys } from "@src/api/queryKeys";
import { useGetScriptStatus } from "@src/api/shops/get-script-status";
import { CustomEventsESMAlert } from "@src/components/MainApp/Alerts/CustomEventsESMAlert";
import { ArchiveCustomEventDialog } from "@src/features/customEvents/components/ArchiveCustomEventDialog";
import { UnarchiveCustomEventDialog } from "@src/features/customEvents/components/UnarchiveCustomEventDialog";
import { CustomEventsDrawer } from "@src/features/customEvents/CustomEventsDrawer";
import { EventsManagerHeader } from "@src/features/eventsManager/components/EventsManagerHeader";
import { EventsManagerTable } from "@src/features/eventsManager/components/EventsManagerTable";
import {
  selectedArchivingEventId,
  selectedUnarchivingEventId,
} from "@src/store/slices/customEvents";
import { isDrawerOpen } from "@src/store/slices/drawers";
import { useIsFetching, useIsMutating } from "@tanstack/react-query";

export const EventsManagerBody = () => {
  const org = useGetOrg();
  const scriptStatus = useGetScriptStatus(org.data?.org.id);
  const combinedCustomEvents = useGetAllCombinedCustomEvents();
  const isCustomDrawerOpen = useSelector(isDrawerOpen("customEvents"));
  const archivingEventId = useSelector(selectedArchivingEventId);
  const unarchivingEventId = useSelector(selectedUnarchivingEventId);
  const isCombinedCustomEventsFetching = useIsFetching({
    queryKey: combinedCustomEventsKeys.all,
  });
  const [showArchived, setShowArchived] = useImmer<boolean>(false);
  const [searchInput, setSearchInput] = useImmer("");

  return (
    <Grid>
      {scriptStatus.data?.type === "isCjs" && <CustomEventsESMAlert />}
      <EventsManagerHeader
        combinedCustomEvents={combinedCustomEvents?.data || []}
        showArchived={showArchived}
        setShowArchived={setShowArchived}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
      />
      <EventsManagerTable
        combinedCustomEvents={combinedCustomEvents?.data || []}
        showArchived={showArchived}
        setShowArchived={setShowArchived}
        searchInput={searchInput}
        isCombinedCustomEventsMutating={isCombinedCustomEventsFetching}
      />
      {isCustomDrawerOpen && (
        <CustomEventsDrawer renderLocation={"eventsManager"} />
      )}
      <ArchiveCustomEventDialog eventId={archivingEventId} />
      <UnarchiveCustomEventDialog eventId={unarchivingEventId} />
    </Grid>
  );
};
